import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

// NOTE: Has all default fields except the email field
export const formSubEntityDefaultAddSettingsFieldsSlugs = [
  ContactSlugEnum.FirstName,
  ContactSlugEnum.Surname,
  ContactSlugEnum.PhoneNumber,
  ContactSlugEnum.CompanyName,
  ContactSlugEnum.Country,
  ContactSlugEnum.State,
  ContactSlugEnum.City,
  ContactSlugEnum.Neighborhood,
  ContactSlugEnum.StreetAddress,
  ContactSlugEnum.StreetNumber,
  ContactSlugEnum.Postcode,
  ContactSlugEnum.TaxNumber,
]

export const HORIZONTAL_LINE_INDEXES = [2, 5, 13]
